'use strict'
import ScrollBooster from "scrollbooster";

let viewport = document.querySelector(`.banners-carousel__content`);
if (viewport) {
    let box = document.querySelector('.banners-carousel__container');
    new ScrollBooster({
        viewport: viewport,
        scrollMode: 'native',
        onUpdate: (data) => {
            if (data.borderCollision.left) {
                box.classList.remove('banners-carousel__container_show-before');
                box.classList.add('banners-carousel__container_show-after');
            } else if (data.borderCollision.right) {
                box.classList.remove('banners-carousel__container_show-after');
                box.classList.add('banners-carousel__container_show-before');
            } else {
                box.classList.add('banners-carousel__container_show-after', 'banners-carousel__container_show-before');
            }
        }
    })
}